import React, { useMemo, useRef } from "react";

const ACTIVE = "#ffffffc7",
  INACTIVE = "#ffffff30";

function getColor(bars: number[], bar: number, percentPlayed: number) {
  if (bar < (bars.length * percentPlayed) / 100) {
    return ACTIVE;
  } else if (bar == Math.ceil((bars.length * percentPlayed) / 100) - 1) {
    return "white";
  } else {
    return INACTIVE;
  }
}

export default function Waveform({
  waveform,
  trimEnd = true,
  className,
  percentPlayed,
  setPercentPlayed,
  ...rest
}: any) {
  // todo: collapse bar width when screen gets narrow

  const waveRef = useRef<HTMLDivElement>();

  const trimmedWaveform = useMemo(() => {
    let newWaveform = [...waveform];
    while (newWaveform[newWaveform.length - 1] === 0) {
      // While the last element is a 0,
      newWaveform.pop(); // Remove that last element
    }
    return newWaveform;
  }, waveform);
  const trimmedPercentPlayed = useMemo(
    () => (trimEnd ? (percentPlayed * waveform.length) / trimmedWaveform.length : percentPlayed),
    [percentPlayed, trimmedWaveform, waveform]
  );

  return (
    <div
      ref={waveRef}
      className={`${className} flex cursor-pointer items-center`}
      onClick={(e) => {
        if (typeof setPercentPlayed !== "function") return;
        if (!waveRef.current) return;
        if (trimEnd)
          setPercentPlayed(
            (-waveRef.current.getBoundingClientRect().x + e.clientX) /
              ((waveform.length / trimmedWaveform.length) * waveRef.current.getBoundingClientRect().width)
          );
        else
          setPercentPlayed(
            (-waveRef.current.getBoundingClientRect().x + e.clientX) / waveRef.current.getBoundingClientRect().width
          );
        // console.log(e.clientX, (waveRef.current.getBoundingClientRect().x - e.clientX) / waveRef.current.getBoundingClientRect().width)
      }}
    >
      {trimmedWaveform.map((bar, i) => (
        <div
          key={i}
          className={`transition`}
          style={{
            backgroundColor: getColor(trimmedWaveform, i, trimmedPercentPlayed),
            width: `${100 / trimmedWaveform.length}%`,
            marginRight: 1,
            height: `${1 + bar * 100}%`,
          }}
        />
      ))}
    </div>
  );
}
